import type { RouteObject } from 'react-router-dom';
import { Navigate } from 'react-router-dom';

import { RequireSection } from '@/shared/routing';

import { ConversationDetailPage } from './ui/pages/ConversationDetailPage';
import { ConversationsListPage } from './ui/pages/ConversationsListPage';

/**
 * The operator inbox subtree, mounted under the authenticated `AppLayout` shell (design §5). One guard
 * for both leaves — `customersRoutes` is the shape this mirrors.
 */
export const conversationsRoutes: RouteObject = {
  path: 'conversations',
  element: <RequireSection section="conversations" />,
  children: [
    { index: true, element: <ConversationsListPage /> },
    { path: ':conversationId', element: <ConversationDetailPage /> },
    { path: '*', element: <Navigate to="/conversations" replace /> },
  ],
};
